<style lang="scss" scoped>
h2,
h3,
h4,
h5,
p {
    margin: 0;
    padding: 0;
}
.dropdown-gray-menu {
    position: absolute;
    right: 0;
    top: 60px;
    z-index: 3000;
    width: 400px;
    .dropdown-menu {
        right: 0;
        top: 60px;
        z-index: 3000;
        width: 420px;
        background-color: white;
        border: 1px #eee solid;
    }
}
.dropdown-menu.notifications:before,
.dropdown-menu.profile:before {
    bottom: 100%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    bottom: 99.2%;
    position: absolute;
    pointer-events: none;
    border-bottom-color: #445467;
    border-width: 9px;
    left: 63%;
}
.dropdown-menu.notifications h3,
.dropdown-menu.profile h3 {
    padding: 2px 15px;
    text-align: center;
    background: #445467;
    color: #fff;
    font-weight: lighter;
    letter-spacing: 1px;
    margin-bottom: 0;
}
.dropdown-menu.notifications h4 {
    padding: 2px 12px;
    border-bottom: 1px #eee solid;
}
.dropdown-menu.notifications h4 span {
    color: #333;
}
.notifications .dropdown-item {
    font-size: 13px;
    padding: 2px 12px;
    color: #888;
}
.dropdown-item {
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    background-color: transparent;
    border: 0;
}
.dropdown-item span {
    color: #606266;
    opacity: 0.6;
}
.timeline_items {
    position: relative;
    display: table;
    table-layout: fixed;
    width: 100%;
    border-bottom: 1px #fafafa solid;
}
.timeline_text {
    display: table-cell;
    text-align: left;
    vertical-align: middle;
    width: 100%;
    padding: 5px 0;
    line-height: 2;
}
.timeline_icon {
    text-align: left;
    color: #67c23a !important;
    vertical-align: middle;
    display: table-cell;
    width: 30px;
    padding: 0 5px 0 0;
    line-height: 0;
}
.timeline_time {
    display: table-cell;
    text-align: right;
    vertical-align: middle;
    width: 80px;
    padding: 0 0 0 5px;
    list-style: none;
    line-height: 24px !important;
}
.timeline_time span {
    font-size: 12px;
    color: #409eff;
}
.timeline_items .timeline_text {
    color: #333;
}
.timeline_read .timeline_text {
    color: #b2b2b2;
}
.shake-enter-active,
.shake-leave-active {
    transition: opacity 1s;
}
/*指定隐藏时的样式*/

.shake-enter,
.shake-leave-to {
    opacity: 0;
}
</style>
<template>
    <div class="wl-container" @click="gobalclick">
        <el-menu class="navbar" mode="horizontal">
            <hamburger
                :toggle-click="toggleSideBar"
                :is-active="sidebar.opened"
                class="hamburger-container"
            />
            <breadcrumb />
            <div class="avatar-container">
                <div class="bellset" @click="goToHandleList">
                    <span>操作手册</span>
                </div>
                <div class="bellset" @click="goToQuestionList">
                    <span>常见问题</span>
                </div>
                <div class="bellset">
                    <el-dropdown trigger="click">
                        <div class="avatar-image">
                            <span class="username-info">{{
                                currentLanguage.displayName
                            }}</span>
                            <i class="el-icon-arrow-down"></i>
                        </div>
                        <el-dropdown-menu slot="dropdown" class="user-dropdown">
                            <el-dropdown-item
                                v-for="(language, index) of languages"
                                :key="index"
                            >
                                <span
                                    style="display: block"
                                    @click="changeLanguage(language.name)"
                                >
                                    <!-- <i :class="language.icon|flag"></i> -->
                                    <i class></i>
                                    {{ language.displayName }}
                                </span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="bellset" @click="showUserAlert">
                    <el-badge
                        v-if="unreadNotificationCount"
                        :value="unreadNotificationCount"
                        class="item-message"
                        type="warning"
                    >
                        <el-button size="medium" type="text">通知</el-button>
                    </el-badge>
                    <el-badge v-else class="item-message" type="warning">
                        <el-button size="medium" type="text">通知</el-button>
                    </el-badge>
                    <transition name="shake">
                        <div class="dropdown-gray-menu" v-show="visiblePop">
                            <div
                                class="dropdown-menu lorvens-box-shadow notifications"
                            >
                                <h3>{{ unreadNotificationCount }}新通知</h3>
                                <h4>
                                    <span
                                        @click.stop.prevent="
                                            setAllNotificationsAsRead
                                        "
                                        v-if="unreadNotificationCount"
                                        >{{ L('SetAllAsRead') }}</span
                                    >
                                    <el-button
                                        type="text"
                                        icon="el-icon-setting"
                                        @click.stop.prevent="
                                            openNotificationSettingsModal
                                        "
                                        class="pull-right"
                                        >{{ L('Settings') }}</el-button
                                    >
                                    <div class="clearfix"></div>
                                </h4>
                                <div class="dropdown-item">
                                    <div
                                        v-for="(
                                            notification, index
                                        ) of notifications"
                                        :key="index"
                                        :class="{
                                            timeline_items:
                                                notification.state != 'READ',
                                            'timeline_items timeline_read':
                                                notification.state == 'READ'
                                        }"
                                        @click="gotoUrl(notification.url)"
                                        href="#"
                                    >
                                        <!-- <span :class="notification.icon"></span>    -->
                                        <span
                                            :class="{
                                                [notification.icon]: true,
                                                timeline_icon: true
                                            }"
                                        ></span>
                                        <span class="timeline_text">{{
                                            notification.text
                                        }}</span>
                                        <span class="timeline_time">
                                            {{ fromNow(notification.time) }}
                                            <span
                                                class="inlineBlock"
                                                v-if="
                                                    notification.state ==
                                                    'UNREAD'
                                                "
                                                @click="
                                                    setNotificationAsRead(
                                                        notification
                                                    )
                                                "
                                                >标记为已读</span
                                            >
                                        </span>
                                    </div>
                                    <div class="otifications-footer">
                                        <div class="text-center">
                                            <router-link
                                                to="/dashboard/notifications"
                                                >{{
                                                    L('SeeAllNotifications')
                                                }}</router-link
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>

                <div
                    class="chatset"
                    title="返回我的账户"
                    v-if="isImpersonatedLogin"
                >
                    <a @click="backToMyAccount()">
                        <i class="fa fa-reply-all" aria-hidden="true"></i>
                    </a>
                </div>

                <el-dropdown trigger="click">
                    <div class="avatar-image">
                        <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">-->

                        <el-badge
                            v-if="ispulishunread == true"
                            value="1"
                            class="item-message"
                            type="warning"
                        >
                            <span class="username-info">{{
                                shownLoginName
                            }}</span>
                        </el-badge>
                        <span v-else class="username-info">{{
                            shownLoginName
                        }}</span>
                        <!-- <div class="topimage">{{shownLoginName}}</div> -->
                    </div>
                    <el-dropdown-menu slot="dropdown" class="user-dropdown">
                        <el-dropdown-item v-if="isImpersonatedLogin">
                            <span
                                style="display: block"
                                @click="backToMyAccount()"
                            >
                                <i class="fa fa-reply-all right-20"></i
                                >返回我的账户
                            </span>
                        </el-dropdown-item>
                        <!-- <el-dropdown-item>
              <span style="display:block;" @click="relevance=true">
                <i class="fa fa-cog right-20"></i>账户管理
              </span>
            </el-dropdown-item>-->
                        <el-dropdown-item>
                            <span style="display: block" @click="publishinfo()">
                                <i class="fa fa-leanpub right-20"></i>

                                <el-badge
                                    v-if="ispulishunread == true"
                                    value="1"
                                    class="item-message"
                                    type="warning"
                                    >{{ L('PublishInfo') }}</el-badge
                                >
                                <span v-else>{{ L('PublishInfo') }}</span>
                            </span>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <span
                                style="display: block"
                                @click="changePassword()"
                            >
                                <i class="fa fa-eye-slash right-20"></i>
                                {{ L('ChangePassword') }}
                            </span>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <span
                                style="display: block"
                                @click="showLoginAttempts()"
                            >
                                <i class="fa fa-history right-20"></i>
                                {{ L('LoginAttempts') }}
                            </span>
                        </el-dropdown-item>

                        <el-dropdown-item divided>
                            <span
                                style="display: block"
                                @click="changeMySettings()"
                            >
                                <i class="fa fa-address-book-o right-20"></i>
                                {{ L('MySettings') }}
                            </span>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <span style="display: block" @click="logout">
                                <i class="fa fa-circle-o-notch right-20"></i
                                >退出
                            </span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-menu>
        <el-col :span="24" class="main">
            <el-col :span="24" class="content-wrapper content-expanded">
                <div class="tags" v-if="showTags">
                    <div id="tags-view-container" class="tags-view-container">
                        <scroll-pane ref="scrollPane" class="tags-view-wrapper">
                            <router-link
                                v-for="(tag, index) in tagsList"
                                ref="tag"
                                :key="tag.path"
                                :class="{ active: isActive(tag.path) }"
                                :to="{
                                    path: tag.path,
                                    query: tag.query,
                                    fullPath: tag.fullPath
                                }"
                                tag="span"
                                @click.middle.native="closeTags(index)"
                                class="tags-view-item"
                            >
                                {{ tag.title }}
                                <span
                                    class="el-icon-close"
                                    @click.prevent.stop="closeTags(index)"
                                />
                            </router-link>
                        </scroll-pane>
                    </div>

                    <!-- 其他操作按钮 -->
                    <div class="tags-close-box">
                        <el-dropdown @command="handleTags">
                            <el-button size="mini">
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </el-button>
                            <el-dropdown-menu size="small" slot="dropdown">
                                <el-dropdown-item command="other"
                                    >关闭其他</el-dropdown-item
                                >
                                <el-dropdown-item command="all"
                                    >关闭所有</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <transition name="fade" mode="out-in">
                    <div class="content-az">
                        <!-- <router-view></router-view> -->
                        <keep-alive :include="cachedPage">
                            <router-view />
                        </keep-alive>
                    </div>
                </transition>
            </el-col>
        </el-col>

        <ChangePasswordModal
            :display.sync="changePasswordModal.display"
        ></ChangePasswordModal>
        <LoginAttemptsModal
            :display.sync="loginAttemptsModal.display"
        ></LoginAttemptsModal>
        <NotificationSettingsModal
            :display.sync="notificationSettingsModal.display"
        ></NotificationSettingsModal>
        <PublishInfoModal
            ref="publishinfo"
            :display.sync="publishInfoModal.display"
        ></PublishInfoModal>
        <MySettingsModal
            :display.sync="mySettingsModal.display"
            :onSave="() => onMySettingsModalSaved()"
        ></MySettingsModal>
    </div>
</template>

<script>
import { SideBarMenu } from '../components/Sidebar/models/SideBarMenu'
import { SideBarMenuItem } from '../components/Sidebar/models/SideBarMenuItem'
import ScrollPane from '@/components/ScollPane'

import MenuUtils from '../components/Sidebar/models/MenuUtils'
import * as _ from 'lodash'
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import AppAuthService from '@/services/common/AppAuthService'
import SessionService from '@/services/common/SessionService'
import ProfileService from '../../../services/admin/ProfileService'
import CFSession from '@/services/common/CFSession'
import ImpersonationService from '@/services/account/ImpersonationService'
import LocalizationService from '@/services/common/LocalizationService'
import NotificationService from '@/services/admin/NotificationService'
import UserNotificationHelper from '../UserNotificationHelper'
import ChangePasswordModal from '../profile/ChangePasswordModal'
import LoginAttemptsModal from '../others/LoginAttemptsModal'
import MySettingsModal from '../profile/MySettingsModal'
import NotificationSettingsModal from '../others/NotificationSettingsModal'
import PublishInfoModal from '../others/PublishInfo'
import * as moment from 'moment'
export default {
    data() {
        return {
            cachedPage:
                'hangfireVoucher,voucherCreate,voucherLogs,sysoplogs,voucherManager,subject,benchindex',
            tagsList: [],
            visiblePop: false, // 不显示
            Visible: false,
            readerEnd: false, // 信息是否已读
            shownLoginName: null,
            profilePicture: null,
            relevance: false,
            dialogVisible: false,
            isImpersonatedLogin: false,
            notifications: null,
            unreadNotificationCount: 0,
            myposition: 'left',
            position: 'left',
            ChangePsw: false,
            createUser: false,
            languages: null,
            tableData: [],
            fileList: [],
            filterText: '',
            formLabel: {},
            currentLanguage: null,
            fetchMessage: {
                State: null,
                MaxResultCount: 0,
                SkipCount: 0
            },
            changePasswordModal: {
                display: false
            },
            loginAttemptsModal: {
                display: false
            },
            mySettingsModal: {
                display: false
            },
            notificationSettingsModal: {
                display: false
            },
            publishInfoModal: {
                display: false
            },
            value: '当前套账：天津公司',
            options: [
                {
                    value: '选项1',
                    label: '当前套账：天津公司'
                },
                {
                    value: '选项2',
                    label: '当前套账：上海公司'
                },
                {
                    value: '选项3',
                    label: '当前套账：北京公司'
                },
                {
                    value: '选项4',
                    label: '当前套账：郑州公司'
                }
            ],
            ispulishunread: false
        }
    },
    created() {
        this.setTags(this.$route)

        this.languages = _.filter(
            LocalizationService.languages,
            (x) => x.isDisabled === false
        )
        this.currentLanguage = LocalizationService.currentLanguage
        this.isImpersonatedLogin = CFSession.ImpersonatorUserId > 0
        this.registerToEvents()
        Promise.all([
            this.GetPulishUnRead(),
            this.getCurrentLoginInformations(),
            this.loadNotifications(),
            this.getProfilePicture()
        ]).then(() => {})
    },
    components: {
        Breadcrumb,
        Hamburger,
        ChangePasswordModal,
        LoginAttemptsModal,
        MySettingsModal,
        NotificationSettingsModal,
        PublishInfoModal,
        ScrollPane
    },
    mounted() {
        var tags = sessionStorage.getItem('Tags' + cf.session.userId)
            ? JSON.parse(sessionStorage.getItem('Tags' + cf.session.userId))
            : []

        if (tags && tags.length > 0) {
            this.tagsList = tags
        } else {
            this.tagsList = []
        }
    },
    computed: {
        ...mapGetters(['sidebar', 'avatar']),
        showTags() {
            if (this.tagsList.length > 1) {
                this.$store.commit(
                    'saveTagsData',
                    JSON.stringify(this.tagsList)
                )
            }
            return this.tagsList.length > 0
        }
    },
    watch: {
        // 对router进行监听，每当访问router时，对tags的进行修改
        $route: async function (newValue, from) {
            this.setTags(newValue)

            const tags = this.$refs.tag
            this.$nextTick(() => {
                if (tags) {
                    for (const tag of tags) {
                        if (tag.to.title === this.$route.title) {
                            this.$refs.scrollPane.moveToTarget(tag, tags)
                            break
                        }
                    }
                }
            })
        }
    },
    methods: {
        // 关闭单个标签
        closeTags(index) {
            const delItem = this.tagsList.splice(index, 1)[0]
            const item = this.tagsList[index]
                ? this.tagsList[index]
                : this.tagsList[index - 1]
            if (item) {
                delItem.title === this.$route.title &&
                    this.$router.push(item.path)
                this.$store.commit(
                    'saveTagsData',
                    JSON.stringify(this.tagsList)
                )
                const latestView = this.tagsList.slice(-1)[0]
                if (latestView) {
                    this.$router.push(latestView) //如果数组不为空则让选中的标签为紧邻关闭标签的那一个
                } else {
                    this.$router.push('/') //如果为空则页面跳转到/
                }
            } else {
                this.$router.push('/')
            }
        },
        // 关闭全部标签
        closeAll() {
            this.tagsList = []
            this.$router.push('/')
            sessionStorage.removeItem('Tags' + cf.session.userId)
            // sessionStorage.removeItem("TenantId");
        },
        // 关闭其他标签
        closeOther() {
            const curItem = this.tagsList.filter((item) => {
                return item.title === this.$route.title
            })
            this.tagsList = curItem
            sessionStorage.setItem(
                'Tags' + cf.session.userId,
                JSON.stringify(this.tagsList)
            )
            // sessionStorage.setItem("TenantId", cf.session.tenantId);
        },
        // 设置标签
        setTags(route) {
            if (!route.meta.NoTabPage) {
                const isExist = this.tagsList.some((item) => {
                    return item.title === route.meta.title
                })
                if (!isExist && route.name != '档案编辑') {
                    this.tagsList.push({
                        title: route.meta.title,
                        path: route.fullPath
                        // name: route.matched[1].components.default.name
                    })
                }

                // cf.session.tenantId =
                //   cf.session.tenantId == null ? "null" : cf.session.tenantId;
                // sessionStorage.setItem("TenantId", cf.session.tenantId);
            }
        },
        // 当关闭所有页面时隐藏
        handleTags(command) {
            command === 'other' ? this.closeOther() : this.closeAll()
        },

        isActive(path) {
            return path === this.$route.fullPath
        },
        goToHandleList() {
            this.$router.push('/helpCenter/workBookUser')
        },
        goToQuestionList() {
            this.$router.push('/helpCenter/questionAdminUser')

            // window.location.href = "/helpCenter/questionAdminUser";
        },
        async GetPulishUnRead() {
            this.ispulishunread = await SessionService.GetPulishUnRead()
        },
        closeit() {
            this.visiblePop = false
        },
        changeMySettings() {
            this.mySettingsModal.display = true
        },
        async onMySettingsModalSaved() {
            this.shownLoginName = await SessionService.getShownLoginName()
            var result = await SessionService.getCurrentLoginInformations()
            this.tenant = result.tenant
            this.user = result.user
        },
        publishinfo() {
            this.ispulishunread = false
            this.$refs.publishinfo.initData(0)
            this.publishInfoModal.display = true
        },
        changePassword() {
            this.changePasswordModal.display = true
        },
        openNotificationSettingsModal() {
            this.notificationSettingsModal.display = true
        },
        showLoginAttempts() {
            this.loginAttemptsModal.display = true
        },
        toggleSideBar() {
            this.$store.dispatch('ToggleSideBar')
        },
        gobalclick(e) {
            this.visiblePop = false
        },
        showUserAlert(e) {
            e.stopPropagation()
            this.visiblePop = true
        },
        clickAlert(e) {
            e.stopPropagation()
            this.visiblePop = false
        },
        logout() {
            this.$store.dispatch('LogOut').then(() => {
                //location.reload(); // 为了重新实例化vue-router对象 避免bug
                AppAuthService.logout()
            })
        },
        async getCurrentLoginInformations() {
            this.shownLoginName = await SessionService.getShownLoginName()
            var result = await SessionService.getCurrentLoginInformations()
            this.tenant = result.tenant
            this.user = result.user
            this.application = result.application
        },
        async getProfilePicture() {
            var result = await ProfileService.getProfilePicture()
            if (result && result.profilePicture) {
                this.profilePicture =
                    'data:image/jpeg;base64,' + result.profilePicture
            }
        },
        async backToMyAccount() {
            await ImpersonationService.backToImpersonator()
        },
        changeLanguage(languageName) {
            const input = {}
            input.languageName = languageName

            ProfileService.changeLanguage(input).then(() => {
                cf.utils.setCookieValue(
                    'CF.Localization.CultureName',
                    languageName,
                    new Date(new Date().getTime() + 5 * 365 * 86400000),
                    cf.appPath
                )

                window.location.reload()
            })
        },
        registerToEvents() {
            cf.event.on('profilePictureChanged', async () => {
                await this.getProfilePicture()
            })

            cf.event.on(
                'app.chat.unreadMessageCountChanged',
                (messageCount) => {
                    this.unreadChatMessageCount = messageCount
                }
            )

            cf.event.on('app.chat.connected', () => {
                this.chatConnected = true
            })

            cf.event.on(
                'cf.notifications.received',
                async (userNotification) => {
                    UserNotificationHelper.show(userNotification)
                    await this.loadNotifications()
                }
            )

            cf.event.on('app.notifications.refresh', async () => {
                await this.loadNotifications()
            })

            cf.event.on('app.notifications.read', (userNotificationId) => {
                for (let i = 0; i < this.notifications.length; i++) {
                    if (
                        this.notifications[i].userNotificationId ===
                        userNotificationId
                    ) {
                        this.notifications[i].state = 'READ'
                    }
                }

                this.unreadNotificationCount -= 1
            })
        },
        async setAllNotificationsAsRead() {
            await UserNotificationHelper.setAllAsRead()
        },
        openNotificationSettingsModal() {
            this.notificationSettingsModal.display = true
        },
        async setNotificationAsRead(userNotification) {
            await UserNotificationHelper.setAsRead(
                userNotification.userNotificationId
            )
            this.readerEnd = true
        },
        fromNow(date) {
            return moment(date).fromNow()
        },
        gotoUrl(url) {
            if (url) {
                location.href = url
            }
        },
        async loadNotifications() {
            this.fetchMessage.MaxResultCount = 3
            var result = await NotificationService.getUserNotifications(
                this.fetchMessage
            )
            this.unreadNotificationCount = result.unreadCount
            this.notifications = []
            $.each(result.items, (index, item) => {
                this.notifications.push(UserNotificationHelper.format(item))
            })
        },
        users() {},
        handleClose(done) {
            done()
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.userDialog .el-dialog .el-table {
    padding-top: 0;
}
.avatar-image {
    cursor: pointer;
}
.avatar-image .topimage {
    width: 40px;
    height: 40px;
    line-height: 40px;
    background-color: #409eff;
    color: white;
    text-align: center;
    border-radius: 50%;
    display: inline-block;
    margin-top: -15px;
}
// .selectaccount .el-input input {
//   border: 1px #1482f0 solid;
//   color: #fff;
//   background-color: #409eff;
// }
// .selectaccount .el-input__suffix i {
//   color: white !important;
// }
.userDialog .el-dialog .el-table th {
    padding: 0 0;
}
ul,
li {
    list-style: none !important;
    margin: 0;
    padding: 0;
}

.noticelist li {
    line-height: 24px;
    height: 24px;
}

.navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;
    .international {
        display: block;
        float: left;
        margin-right: 20px;
        cursor: pointer;
    }
    .el-dialog__header {
        border-bottom: 1px #f1f1f1 solid;
    }
    .bellset {
        float: left;
        margin-right: 30px;
        color: #606266;
        font-size: 14px;
        cursor: pointer;
    }
    .el-badge__content.is-fixed {
        top: 12px !important;
    }
    .chatset {
        float: left;
        margin-right: 20px;
        color: #409eff;
        font-size: 18px;
    }
    .item-message {
        position: relative;
    }

    .hamburger-container {
        line-height: 58px;
        height: 50px;
        float: left;
        padding: 0 10px;
    }
    .screenfull {
        position: absolute;
        right: 90px;
        top: 16px;
        color: red;
    }
    .avatar-container {
        height: 50px;
        display: inline-block;
        position: absolute;
        right: 35px;
        .avatar-wrapper {
            cursor: pointer;
            margin-top: 5px;
            position: relative;
            .user-avatar {
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }
            .el-icon-caret-bottom {
                position: absolute;
                right: -20px;
                top: 25px;
                font-size: 12px;
            }
        }
    }
}
</style>
<style>
.tags-view-container {
    height: 30px;
    width: 100%;
    float: left;
}

.tags-view-container .tags-view-wrapper .tags-view-item {
    display: inline-block;
    position: relative;
    cursor: pointer;
    height: 26px;
    line-height: 26px;
    border: 1px solid #d8dce5;
    color: #495060;
    background: #fff;
    padding: 0 8px;
    font-size: 12px;
    margin-left: 5px;
    margin-top: 4px;
}

.tags-view-container .tags-view-wrapper .tags-view-item:first-of-type {
    margin-left: 15px;
}

.tags-view-container .tags-view-wrapper .tags-view-item:last-of-type {
    margin-right: 15px;
}

.tags-view-container .tags-view-wrapper .tags-view-item.active::before {
    content: '';
    background: #2d8cf0;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: relative;
    margin-right: 2px;
}

.tags-view-container .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.tags-view-container .contextmenu li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
}

.tags-view-container .contextmenu li:hover {
    background: #eee;
}
</style>
<style>
.menu-collapsed .el-icon-arrow-right:before {
    display: none;
}

.tags {
    position: relative;
    overflow: hidden;
    border: 1px solid #f0f0f0;
    background: #f0f0f0;
}

.tags ul {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    display: none;
}

.tags-li {
    float: left;
    margin: 3px 5px 2px 3px;
    border-radius: 3px;
    font-size: 13px;
    overflow: hidden;
    height: 23px;
    line-height: 23px;
    border: 1px solid #e9eaec;
    background: #fff;
    padding: 3px 5px 4px 12px;
    vertical-align: middle;
    color: #666;
    -webkit-transition: all 0.3s ease-in;
    transition: all 0.3s ease-in;
}

.tags-li-icon {
    cursor: pointer;
}

.tags-li:not(.active):hover {
    background: #f8f8f8;
}

.tags-li-title {
    float: left;
    max-width: 80px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 5px;
    color: #666;
    text-decoration: none;
}
.tags-close-box {
    box-sizing: border-box;
    text-align: center;
    z-index: 10;
    float: right;
    margin-right: 1px;
    line-height: 2;
}
</style>
<style>
.tags-view-wrapper .tags-view-item .el-icon-close {
    width: 16px;
    height: 16px;
    vertical-align: 2px;
    border-radius: 50%;
    text-align: center;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform-origin: 100% 50%;
}

.tags-view-wrapper .tags-view-item .el-icon-close:before {
    transform: scale(0.6);
    display: inline-block;
    vertical-align: -3px;
}

.tags-view-wrapper .tags-view-item .el-icon-close:hover {
    background-color: #ef2b74;
    color: #fff;
}
</style>
